import React, { useState, useMemo, useContext } from "react";
import { useNavigate } from "react-router-dom";

import "./MyFleetBreadcrumb.scss";

import { Button, Icon } from "abs-ui-components";

import ImportVessel from "../ImportVessel/ImportVessel";
import ImportFuelRegistry from "../ImportFuelRegistry/ImportFuelRegistry";
import FuelRegistryTemplateWizard from "../VesselDetails/FuelRegistryTemplateWizard";
import AbsModal from "../../common/absModal/AbsModal";
import BreadCrumb from "../../common/breadCrumb/BreadCrumb";
import { ClaimsContext } from "../../services/ClaimsService";
import { FeatureType } from "../../constants/FeatureToggles";

const baseURL = process.env.REACT_APP_BASE_URL;

export const MyFleetBreadcrumb = ({
	refetchVesselList,
	handleExportTableOnClick,
	exportFleetEnabled,
}) => {
	const navigate = useNavigate();
	const { userHasFeature, userFeaturesAreLoaded } = useContext(ClaimsContext);
	const showImportFuelRegistryButton =
		userFeaturesAreLoaded && userHasFeature(FeatureType.ImportFuelRegistry);
	const showDownloadFuelRegistryTemplateButton =
		userFeaturesAreLoaded &&
		userHasFeature(FeatureType.DownloadOrUpdateFuelRegistryTemplate);

	const [isImportVesselModalOpen, setIsImportVesselModalOpen] =
		useState(false);
	const [isImportFuelRegistryModalOpen, setIsImportFuelRegistryModalOpen] =
		useState(false);
	const [isFuelRegistryTemplateWizardOpen, setIsFuelRegistryTemplateWizardOpen] =
		useState(false);

	const toggleImportVessel = (success) => {
		setIsImportVesselModalOpen(!isImportVesselModalOpen);
		if (success) {
			refetchVesselList();
		}
	};

	const toggleImportFuelRegistry = (success) => {
		setIsImportFuelRegistryModalOpen((prev) => !prev);
		if (success) {
			refetchVesselList();
		}
	};

	const breadcrumb = useMemo(
		() => [{ label: "My Fleet", url: "", navId: "myfleet_navId" }],
		[]
	);

	return (
		<>
			<div className="my-fleet-actions-container">
				<BreadCrumb items={breadcrumb} />
				<div className="actions-buttons-right">
					<div className="enroll-import-buttons">
						<Button
							startIcon={<Icon icon={"add"} />}
							className="icon-gap"
							onClick={() => {
								navigate("enroll-vessel");
							}}
						>
							Enroll Vessel
						</Button>

						<Button
							startIcon={<Icon icon={"exit_to_app"} />}
							className="icon-gap"
							onClick={toggleImportVessel}
						>
							Import Vessels
						</Button>
					</div>
					<div className="export-actions-right">
						<Button
							disabled={!exportFleetEnabled}
							startIcon={<Icon icon="ios_share" />}
							onClick={handleExportTableOnClick}
							variant="secondary"
							className=""
						>
							{exportFleetEnabled
								? "Export Vessels"
								: "Please wait..."}
						</Button>
						<div className="fuel-registry-actions">
							{showImportFuelRegistryButton && (
								<Button
									startIcon={<Icon icon={"upload_file"} />}
									className="icon-gap"
									onClick={toggleImportFuelRegistry}
								>
									Import Fuel Registry
								</Button>
							)}
							{showDownloadFuelRegistryTemplateButton && (
								<Button
									startIcon={<Icon icon="download" />}
									className="icon-gap"
									onClick={() => setIsFuelRegistryTemplateWizardOpen(true)}
								>
									Download/Update Fuel Registry Template
								</Button>
							)}
						</div>
					</div>
				</div>
			</div>
			<div className="confirmation-modal-container">
				{isImportVesselModalOpen && (
					<AbsModal
						isOpen={isImportVesselModalOpen}
						title="Import Vessel(s) "
						onClose={setIsImportVesselModalOpen}
						close={toggleImportVessel}
					>
						<ImportVessel cancelImportVessel={toggleImportVessel} />
					</AbsModal>
				)}
				{isImportFuelRegistryModalOpen && (
					<AbsModal
						isOpen={isImportFuelRegistryModalOpen}
						title="Import Fuel Registry"
						onClose={setIsImportFuelRegistryModalOpen}
						close={toggleImportFuelRegistry}
					>
						<ImportFuelRegistry
							cancelImportFuelRegistry={toggleImportFuelRegistry}
						/>
					</AbsModal>
				)}
				<FuelRegistryTemplateWizard
					isOpen={isFuelRegistryTemplateWizardOpen}
					onClose={() => setIsFuelRegistryTemplateWizardOpen(false)}
				/>
			</div>
		</>
	);
};
